import compare from '../../../assets/svg/copare.svg'
import { DataContext } from '../../Context/Context'
import React, { useContext } from 'react';
import { Pagination, Navigation, FreeMode } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import ProductCard0 from '../../ProductCardAll/ProductCard0/ProductCard0';



function CompareEmpty() {

    const value = useContext(DataContext);
    const [products, setProducts] = value.products;
    const addCart = value.addCart;


    return (

        <div className="container-xl">
            <div className="container h-100 wrapper-CartEmpty marginTop">
                <div className="row justify-content-center border rounded my-5 ">
                    <img src={compare} className='svgEmptyCart' alt="مقایسه محصولات" />
                    <h3 className='text-center py-5 fw-bold'> لیست مقایسه محصولات  خالی است. </h3>
                    <div className="text-center">
                        <p className='text-secondary'>هیچ محصولی انتخاب نشده است.</p>
                        <p className='text-secondary'> برای مقایسه دو محصول را در صفحه فروشگاه انتخاب کنید. </p>
                    </div>
                </div>
            </div>
            <div className="container my-2">
                <div className="row products-wrapper border rounded ">
                    <div className="row  ">
                        <Swiper
                            slidesPerView={1}
                            breakpoints={{
                                768: { slidesPerView: 3 },
                                1200: { slidesPerView: 5 }
                            }}
                            spaceBetween={30}
                            freeMode={true}
                            navigation={true}
                            modules={[FreeMode, Pagination, Navigation]}
                            className="mySwiper swiperProsucts pb-5"
                        >
                            {
                                products.map(product => (
                                    <SwiperSlide key={product._id} className='products-wrapper ' >
                                        <ProductCard0 product={product} classes='swiper-product-card ' />
                                    </SwiperSlide>
                                ))
                            }
                        </Swiper>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CompareEmpty